const state = {
    admin: {}
}

export default {
    state,

}